import type { RefObject } from 'react';
import { createContext } from 'react';
import type { Google } from '../../../app-kit/components/PcaMap/types';
import type { PcaMapContextProviderProps } from './PcaMapContextProvider';

export interface PcaMapState {
  ref?: RefObject<HTMLDivElement | null>;
  map?: google.maps.Map;
  google?: Google;
  initialConfig?: Readonly<PcaMapContextProviderProps>;
  isLoading: boolean;
}

export const PcaMapContext = createContext<PcaMapState>({
  isLoading: true,
});
